"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("@material-ui/core/styles");
const Radio_1 = __importDefault(require("@material-ui/core/Radio"));
const useStyles = styles_1.makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px #DFDFE6, inset 0 -1px 0 #DFDFE6',
        backgroundColor: '#ffffff',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ffffff',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#2EA0DC',
        boxShadow: 'none',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#2EA0DC',
        },
    },
});
// Inspired by blueprintjs
function StyledRadio(props) {
    const classes = useStyles();
    return (react_1.default.createElement(Radio_1.default, Object.assign({ className: classes.root, disableRipple: true, color: "default", checkedIcon: react_1.default.createElement("span", { className: clsx_1.default(classes.icon, classes.checkedIcon) }), icon: react_1.default.createElement("span", { className: classes.icon }) }, props)));
}
exports.default = StyledRadio;
